(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spp-all-collections"] && !Shopify.designMode) return;
  try {
    
  const setupAllCollections = (section) => {
    if (!section || section.dataset.sppCollectionsReady === 'true') return;
    section.dataset.sppCollectionsReady = 'true';

    const search = section.querySelector('[data-spp-collection-search]');
    const cards = Array.from(section.querySelectorAll('[data-spp-collection-card]'));
    const empty = section.querySelector('[data-spp-collection-empty]');

    if (!search) return;

    const filterCollections = () => {
      const query = search.value.trim().toLocaleLowerCase();
      let visibleCount = 0;

      cards.forEach((card) => {
        const visible = card.dataset.collectionTitle.includes(query);
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (empty) empty.hidden = visibleCount !== 0;
    };

    search.addEventListener('input', filterCollections);
  };

  document.querySelectorAll('[data-spp-all-collections]').forEach(setupAllCollections);

  document.addEventListener('shopify:section:load', (event) => {
    setupAllCollections(event.target.querySelector('[data-spp-all-collections]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spp-artboard-content"] && !Shopify.designMode) return;
  try {
    


function sppCategoryStrips(){document.querySelectorAll('.spp-category-strip').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const track=section.querySelector('.spp-category-strip__track'),button=section.querySelector('button');const update=()=>{button.hidden=track.scrollWidth<=track.clientWidth+2;};button.addEventListener('click',()=>{const end=track.scrollLeft>=track.scrollWidth-track.clientWidth-2;track.scrollTo({left:end?0:track.scrollLeft+track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});});new ResizeObserver(update).observe(track);update();});}sppCategoryStrips();document.addEventListener('shopify:section:load',sppCategoryStrips);
function abCountdowns(){document.querySelectorAll('[data-ab-countdown]').forEach(el=>{if(el.dataset.ready)return;el.dataset.ready='true';const end=Date.parse(el.dataset.abCountdown);if(!Number.isFinite(end)){el.hidden=true;return;}const update=()=>{const s=Math.max(0,Math.floor((end-Date.now())/1000));if(!s){el.hidden=true;return;}el.textContent=[Math.floor(s/86400)+'d',Math.floor(s%86400/3600)+'h',Math.floor(s%3600/60)+'m',s%60+'s'].join(' : ');};update();setInterval(update,1000);});}abCountdowns();document.addEventListener('shopify:section:load',abCountdowns);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spp-back-to-top"]) return;
  try {
    
(function(){
 function init(){
  const button=document.querySelector('[data-spp-back-top]');
  if(!button||button.dataset.bound)return;
  button.dataset.bound='true';
  const ring=button.querySelector('.spp-back-top-progress');
  let pending=false;
  function update(){
   const root=document.documentElement;
   const max=Math.max(0,root.scrollHeight-window.innerHeight);
   const y=Math.max(0,window.scrollY);
   const progress=max?Math.min(100,y/max*100):0;
   button.hidden=y<400;
   ring.style.strokeDashoffset=String(100-progress);
   pending=false;
  }
  function queue(){if(!pending){pending=true;requestAnimationFrame(update)}}
  window.addEventListener('scroll',queue,{passive:true});
  window.addEventListener('resize',queue,{passive:true});
  if('ResizeObserver' in window)new ResizeObserver(queue).observe(document.body);
  button.addEventListener('click',function(){
   const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
   window.scrollTo({top:0,behavior:reduced?'auto':'smooth'});
   const target=document.querySelector('[data-sp-header] .sp-logo');
   if(target)target.focus({preventScroll:true});
  });
  update();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spp-best-sellers"] && !Shopify.designMode) return;
  try {
    
function sppBestInit(root){
 root.querySelectorAll('.spp-best').forEach(section=>{
  if(section.dataset.bestReady)return;
  section.dataset.bestReady='true';
  const track=section.querySelector('.spp-best__products');
  const arrows=section.querySelectorAll('[data-best-scroll]');
  const pager=section.querySelector('[data-best-pager]');
  const range=pager.querySelector('input');
  const dots=pager.querySelector('.spp-best__dots');
  let positions=[];
  const refresh=()=>{
   const maximum=Math.max(0,track.scrollWidth-track.clientWidth);
   const overflow=maximum>2;
   pager.hidden=!overflow;
   arrows.forEach(button=>{button.hidden=!overflow;button.disabled=button.dataset.bestScroll==='-1'?track.scrollLeft<=2:track.scrollLeft>=maximum-2;});
   range.value=maximum?Math.min(100,Math.max(0,track.scrollLeft/maximum*100)):0;
   let nearest=0;
   positions.forEach((position,index)=>{if(Math.abs(position-track.scrollLeft)<Math.abs(positions[nearest]-track.scrollLeft))nearest=index;});
   [...dots.children].forEach((button,index)=>button.setAttribute('aria-current',String(index===nearest)));
  };
  const rebuild=()=>{
   const maximum=Math.max(0,track.scrollWidth-track.clientWidth);
   positions=[0];
   const steps=Math.min(4,Math.max(1,Math.ceil(maximum/Math.max(1,track.firstElementChild?.getBoundingClientRect().width||track.clientWidth))));
   for(let i=1;i<=steps;i++)positions.push(maximum*i/steps);
   dots.replaceChildren();
   positions.forEach((position,index)=>{
    const button=document.createElement('button');
    button.type='button';button.className='spp-best__dot';
    button.setAttribute('aria-label',pager.dataset.dotLabel.replace('[number]',String(index+1)));
    button.setAttribute('aria-controls',track.id);
    button.addEventListener('click',()=>track.scrollTo({left:position,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'}));
    dots.append(button);
   });
   refresh();
  };
  range.addEventListener('input',()=>track.scrollTo({left:(track.scrollWidth-track.clientWidth)*Number(range.value)/100,behavior:'instant'}));
  arrows.forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.bestScroll)*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})));
  track.addEventListener('scroll',refresh,{passive:true});
  const observer=new ResizeObserver(rebuild);observer.observe(track);rebuild();
 });
}
sppBestInit(document);document.addEventListener("shopify:section:load",()=>sppBestInit(document));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spp-cart-main"]) return;
  try {
    
if (!customElements.get('spp-cart-main')) {
  customElements.define('spp-cart-main', class extends HTMLElement {
    connectedCallback() {
      this.strings = {
        added: this.dataset.messageAdded,
        updated: this.dataset.messageUpdated,
        removed: this.dataset.messageRemoved,
        error: this.dataset.messageError,
        noteSaved: this.dataset.messageNoteSaved,
        noteError: this.dataset.messageNoteError
      };
      this.quantityHandler = this.onQuantityClick.bind(this);
      this.inputHandler = this.onQuantityInput.bind(this);
      this.noteHandler = this.onNoteInput.bind(this);
      this.recommendationHandler = this.onRecommendationSubmit.bind(this);
      this.selectionHandler = this.onSelectionChange.bind(this);
      this.bulkHandler = this.onBulkRemoveClick.bind(this);
      this.addEventListener('click', this.bulkHandler);
      this.addEventListener('change', this.selectionHandler);
      this.addEventListener('click', this.quantityHandler);
      this.addEventListener('change', this.inputHandler);
      this.addEventListener('input', this.noteHandler);
      document.addEventListener('submit', this.recommendationHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.bulkHandler);
      this.removeEventListener('change', this.selectionHandler);
      this.removeEventListener('click', this.quantityHandler);
      this.removeEventListener('change', this.inputHandler);
      this.removeEventListener('input', this.noteHandler);
      document.removeEventListener('submit', this.recommendationHandler);
      clearTimeout(this.noteTimer);
    }

    onSelectionChange(event) {
      const input = event.target.closest('[data-spp-select-item],[data-spp-select-all]');
      if (!input || !this.contains(input)) return;
      if (input.matches('[data-spp-select-all]')) {
        this.querySelectorAll('[data-spp-select-item]').forEach(item => {item.checked = input.checked;});
      }
      this.updateSelection();
    }

    updateSelection() {
      const items = [...this.querySelectorAll('[data-spp-select-item]')];
      const selected = items.filter(input => input.checked);
      const all = this.querySelector('[data-spp-select-all]');
      const bulk = this.querySelector('[data-spp-remove-selected]');
      if (all) {
        all.checked = items.length > 0 && selected.length === items.length;
        all.indeterminate = selected.length > 0 && selected.length < items.length;
      }
      if (bulk) bulk.disabled = selected.length === 0 || this.classList.contains('is-loading');
      items.forEach(input => input.closest('.spp-cart-item')?.classList.toggle('is-selected', input.checked));
    }

    async onBulkRemoveClick(event) {
      const button = event.target.closest('[data-spp-remove-selected]');
      if (!button || !this.contains(button)) return;
      event.preventDefault();
      const keys = [...this.querySelectorAll('[data-spp-select-item]:checked')].map(input => input.value);
      if (!keys.length || this.classList.contains('is-loading')) return;
      this.setLoading(true);
      try {
        const updates = Object.fromEntries(keys.map(key => [key, 0]));
        const response = await fetch(this.dataset.cartUpdateUrl, {
          method:'POST',
          headers:{'Content-Type':'application/json', Accept:'application/json'},
          body:JSON.stringify({updates, sections:this.sectionIds(), sections_url:window.location.pathname})
        });
        const state = await response.json();
        if (!response.ok || state.errors || state.status) throw new Error(state.description || state.message || this.strings.error);
        await this.refreshSections(state, keys.length+' selected cart item'+(keys.length===1?'':'s')+' removed.');
      } catch(error) {
        this.setLoading(false);
        this.showError(error.message || this.strings.error);
        this.updateSelection();
      }
    }

    onQuantityClick(event) {
      const button = event.target.closest('[data-spp-quantity],[data-spp-remove]');
      if (!button || !this.contains(button)) return;
      event.preventDefault();
      const line = Number(button.dataset.line);
      const quantity = button.hasAttribute('data-spp-remove') ? 0 : Number(button.dataset.quantity);
      this.changeLine(line, Math.max(0, quantity), button);
    }

    onQuantityInput(event) {
      const input = event.target.closest('[data-spp-quantity-input]');
      if (!input || !this.contains(input)) return;
      const quantity = Math.max(0, Number(input.value) || 0);
      this.changeLine(Number(input.dataset.line), quantity, input);
    }

    onNoteInput(event) {
      const note = event.target.closest('[data-spp-cart-note]');
      if (!note || !this.contains(note)) return;
      clearTimeout(this.noteTimer);
      this.noteTimer = setTimeout(async () => {
        try {
          const response = await fetch(this.dataset.cartUpdateUrl, {
            method: 'POST',
            headers: {'Content-Type': 'application/json', Accept: 'application/json'},
            body: JSON.stringify({note: note.value})
          });
          if (!response.ok) throw new Error();
          this.announce(this.strings.noteSaved);
        } catch (error) {
          this.showError(this.strings.noteError);
        }
      }, 500);
    }

    async onRecommendationSubmit(event) {
      const form = event.target.closest('[data-spp-cart-recommendations] .sp-cart-form');
      if (!form || !document.body.contains(this)) return;
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const scrollPosition = window.scrollY;
      if (button) button.disabled = true;
      try {
        const body = new FormData(form);
        const response = await fetch(this.dataset.cartAddUrl, {method: 'POST', headers: {Accept: 'application/json'}, body});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.strings.error);
        const cartResponse = await fetch(`${this.dataset.cartUrl}.js`, {headers: {Accept: 'application/json'}});
        const cartState = await cartResponse.json();
        await this.refreshSections(cartState, this.strings.added);
        window.scrollTo({top: scrollPosition, behavior: 'instant'});
      } catch (error) {
        this.showError(error.message || this.strings.error);
        if (button) button.disabled = false;
      }
    }

    async changeLine(line, quantity, trigger) {
      if (!line && line !== 0) return;
      this.setLoading(true);
      const sectionIds = this.sectionIds();
      try {
        const response = await fetch(this.dataset.cartChangeUrl, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({line, quantity, sections: sectionIds, sections_url: window.location.pathname})
        });
        const state = await response.json();
        if (!response.ok || state.errors) throw new Error(state.description || state.message || state.errors || this.strings.error);
        this.replaceSections(state.sections || {});
        this.updateCounts(state.item_count);
        this.publishUpdate(state);
        const nextMain = document.querySelector(`spp-cart-main[data-section-id="${this.dataset.sectionId}"]`);
        if (nextMain) nextMain.announce(quantity === 0 ? this.strings.removed : this.strings.updated);
        const nextInput = document.querySelector(`[data-spp-quantity-input][data-line="${line}"]`);
        if (nextInput && trigger && trigger.hasAttribute('data-spp-quantity')) nextInput.focus();
      } catch (error) {
        this.setLoading(false);
        this.showError(error.message || this.strings.error);
      }
    }

    async refreshSections(cartState, message) {
      const sectionIds = this.sectionIds();
      const response = await fetch(`${this.dataset.cartUrl}?sections=${encodeURIComponent(sectionIds.join(','))}`);
      if (!response.ok) throw new Error(this.strings.error);
      const sections = await response.json();
      this.replaceSections(sections);
      this.updateCounts(cartState.item_count);
      this.publishUpdate(cartState);
      const nextMain = document.querySelector(`spp-cart-main[data-section-id="${this.dataset.sectionId}"]`);
      if (nextMain) nextMain.announce(message);
    }

    sectionIds() {
      const ids = [this.dataset.sectionId];
      const recommendations = document.querySelector('[data-spp-cart-recommendations]');
      if (recommendations?.dataset.sectionId) ids.push(recommendations.dataset.sectionId);
      if (document.getElementById('shopify-section-cart-icon-bubble')) ids.push('cart-icon-bubble');
      return ids;
    }

    replaceSections(sections) {
      Object.entries(sections).forEach(([id, html]) => {
        if (!html) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        if (id === this.dataset.sectionId) {
          const source = parsed.querySelector('spp-cart-main');
          const target = document.querySelector(`spp-cart-main[data-section-id="${id}"]`);
          if (source && target) target.replaceWith(source);
        } else {
          const source = parsed.querySelector(`[data-spp-cart-recommendations][data-section-id="${id}"]`) || parsed.querySelector('#shopify-section-cart-icon-bubble');
          const target = document.querySelector(`[data-spp-cart-recommendations][data-section-id="${id}"]`) || document.querySelector('#shopify-section-cart-icon-bubble');
          if (source && target) target.replaceWith(source);
        }
      });
    }

    updateCounts(count) {
      document.querySelectorAll('[data-cart-count],[data-spp-cart-count],.cart-count-bubble span[aria-hidden="true"]').forEach(element => {
        element.textContent = element.hasAttribute('data-spp-cart-count') ? `${count} ${count === 1 ? this.dataset.itemSingular : this.dataset.itemPlural}` : count;
      });
      document.querySelectorAll('.sp-header-actions a[href="/cart"],.sp-header-actions a[href$="/cart"]').forEach(link => {
        const label = link.querySelector('span');
        if (label) label.textContent = `${this.dataset.cartLabel} (${count})`;
        link.setAttribute('aria-label', `${this.dataset.cartLabel} (${count})`);
      });
    }

    publishUpdate(cartState) {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'spp-cart', cartData: cartState});
      document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: cartState}}));
    }

    setLoading(loading) {
      this.classList.toggle('is-loading', loading);
      this.setAttribute('aria-busy', loading ? 'true' : 'false');
    }

    announce(message) {
      const live = this.querySelector('[data-spp-cart-live]');
      if (live) live.textContent = message;
    }

    showError(message) {
      const error = this.querySelector('[data-spp-cart-errors]');
      if (error) error.textContent = message;
      this.announce(message);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spp-cart-recommendations"]) return;
  try {
    
if (!customElements.get('spp-cart-recommendations')) {
  customElements.define('spp-cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-spp-recommendation-results]');
      this.limit = Number(this.dataset.limit) || 4;
      this.cartIds = new Set((this.dataset.productIds || '').split(',').filter(Boolean));
      this.bindArrows();
      if (this.dataset.enableComplementary === 'true' && this.dataset.recommendationsPerformed !== 'true' && this.cartIds.size) this.loadComplementary();
    }

    async loadComplementary() {
      const existingCards = [...this.querySelectorAll('[data-spp-recommendation-results] > spp-candidate')];
      const complementaryCards = [];
      const seen = new Set(this.cartIds);
      try {
        const responses = await Promise.all([...this.cartIds].map(productId => {
          const url = `${this.dataset.recommendationsUrl}?section_id=${encodeURIComponent(this.dataset.sectionId)}&product_id=${encodeURIComponent(productId)}&limit=${this.limit}&intent=complementary`;
          return fetch(url).then(response => response.ok ? response.text() : '');
        }));
        responses.forEach(text => {
          if (!text) return;
          const parsed = new DOMParser().parseFromString(text, 'text/html');
          parsed.querySelectorAll('[data-spp-recommendation-results] > spp-candidate').forEach(card => {
            const id = card.dataset.productId;
            if (!id || seen.has(id) || complementaryCards.length >= this.limit) return;
            seen.add(id);
            complementaryCards.push(card);
          });
        });
        existingCards.forEach(card => {
          const id = card.dataset.productId;
          if (!id || seen.has(id) || complementaryCards.length >= this.limit) return;
          seen.add(id);
          complementaryCards.push(card);
        });
        if (complementaryCards.length) this.track.replaceChildren(...complementaryCards.slice(0, this.limit));
        this.bindArrows();
      } catch (error) {
        this.bindArrows();
      }
    }

    bindArrows() {
      if (!this.track) return;
      const previous = this.querySelector('[data-spp-rec-prev]');
      const next = this.querySelector('[data-spp-rec-next]');
      if (!previous || !next) return;
      const update = () => {
        previous.disabled = this.track.scrollLeft < 2;
        next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 3;
      };
      previous.onclick = () => this.track.scrollBy({left: -this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      next.onclick = () => this.track.scrollBy({left: this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      this.track.onscroll = update;
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spp-clean-header"]) return;
  try {
    
(function(){
 function init(){
  document.querySelectorAll('[data-sp-catalog]').forEach(menu=>{
   if(menu.dataset.bound)return;menu.dataset.bound='1';
   const trigger=menu.querySelector('.sp-catalog-trigger'),desktop=window.matchMedia('(min-width:990px)'),search=menu.querySelector('[data-sp-menu-search]'),clear=menu.querySelector('[data-sp-menu-clear]'),results=menu.querySelector('[data-sp-menu-results]'),title=menu.querySelector('[data-sp-workspace-title]');
   let mode=menu.dataset.defaultMode||'categories',department=Number(menu.dataset.defaultDepartment)||0,timer;
   menu.dataset.spActiveMode=mode;
   function showDepartment(index){
    department=index;
    menu.querySelectorAll('[data-sp-department]').forEach(el=>{const active=Number(el.dataset.spDepartment)===index;el.classList.toggle('is-active',active);el.setAttribute('aria-pressed',active?'true':'false')});
    menu.querySelectorAll('[data-sp-department-panel]').forEach(el=>{const active=Number(el.dataset.spDepartmentPanel)===index;el.hidden=!active;el.classList.toggle('is-active',active)});
    const panel=menu.querySelector('[data-sp-department-panel="'+index+'"]');if(panel&&title&&mode==='categories')title.textContent=panel.dataset.title;
    menu.querySelectorAll('[data-sp-workspace-icon]').forEach(icon=>{icon.hidden=mode!=='categories'||Number(icon.dataset.spWorkspaceIcon)!==index});
    resetSearch(false);
   }
   function showMode(next){
    mode=next;
    menu.dataset.spActiveMode=next;
    menu.querySelectorAll('[data-sp-mode-tab]').forEach(btn=>btn.setAttribute('aria-selected',btn.dataset.spModeTab===next?'true':'false'));
    menu.querySelectorAll('[data-sp-rail-mode]').forEach(el=>{el.hidden=el.dataset.spRailMode!==next;el.classList.toggle('is-active',el.dataset.spRailMode===next)});
    menu.querySelectorAll('[data-sp-workspace-mode]').forEach(el=>{el.hidden=el.dataset.spWorkspaceMode!==next;el.classList.toggle('is-active',el.dataset.spWorkspaceMode===next)});
    if(title)title.textContent=next==='categories'?(menu.querySelector('[data-sp-department-panel="'+department+'"]')?.dataset.title||'Categories'):next==='brands'?'Brands':'Popular';
    menu.querySelectorAll('[data-sp-workspace-icon]').forEach(icon=>{icon.hidden=next!=='categories'||Number(icon.dataset.spWorkspaceIcon)!==department});
    resetSearch(false);
   }
   function close(refocus){menu.open=false;document.documentElement.classList.remove('sp-catalog-open');showMobileScreen('root');if(refocus)trigger.focus()}
   function showMobileScreen(name){menu.querySelectorAll('[data-sp-mobile-screen]').forEach(el=>{const active=el.dataset.spMobileScreen===name;el.hidden=!active;el.classList.toggle('is-active',active)})}
   function resetSearch(focus){if(!search)return;search.value='';if(clear)clear.hidden=true;if(results)results.hidden=true;const active=menu.querySelector('[data-sp-workspace-mode="'+mode+'"]');if(active)active.hidden=false;if(focus)search.focus()}
   function searchNormalise(value){return (value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim()}
    function searchMatches(value,term){const text=searchNormalise(value),query=searchNormalise(term);return Boolean(query)&&(text.includes(query)||text.replace(/\s+/g,'').includes(query.replace(/\s+/g,'')))}
    function runSearch(){
    if(!search||!results)return;const query=search.value.trim(),modePanel=menu.querySelector('[data-sp-workspace-mode="'+mode+'"]'),list=results.querySelector('.sp-menu-results-list'),empty=results.querySelector('.sp-menu-empty'),status=results.querySelector('.sp-results-count');
    if(clear)clear.hidden=!query;if(!query){resetSearch(false);return}
    const source=mode==='categories'?menu.querySelector('[data-sp-workspace-mode="categories"]'):modePanel,seen=new Set();
    const candidates=[...source.querySelectorAll('[data-sp-search-link]')].filter(a=>{
     const category=a.closest('[data-sp-search-group]')?.dataset.spSearchGroup||'';
     const departmentName=a.closest('[data-sp-department-panel]')?.dataset.title||'';
     const haystack=(a.textContent+' '+category+' '+departmentName).trim();
     const match=searchMatches(haystack,query),key=a.href;
     if(!match||seen.has(key))return false;
     seen.add(key);return true;
    });list.replaceChildren();
    candidates.slice(0,32).forEach(a=>{const clone=document.createElement('a');clone.href=a.href;clone.textContent=a.textContent.trim();list.appendChild(clone)});
    modePanel.hidden=true;results.hidden=false;empty.hidden=candidates.length>0;list.hidden=candidates.length===0;status.textContent=candidates.length?candidates.length+' matching menu links':'';
   }
   menu.querySelectorAll('[data-sp-mode-tab]').forEach(btn=>btn.addEventListener('click',()=>{clearTimeout(timer);showMode(btn.dataset.spModeTab)}));
   menu.querySelectorAll('[data-sp-department]').forEach(btn=>{const index=Number(btn.dataset.spDepartment);btn.addEventListener('click',()=>showDepartment(index));btn.addEventListener('focus',()=>showDepartment(index));btn.addEventListener('mouseenter',()=>{clearTimeout(timer);timer=setTimeout(()=>showDepartment(index),Number(menu.dataset.hoverDelay)||200)})});
   menu.addEventListener('mouseleave',()=>clearTimeout(timer));
   if(search)search.addEventListener('input',runSearch);if(clear)clear.addEventListener('click',()=>resetSearch(true));
   menu.querySelectorAll('[data-sp-main-search]').forEach(btn=>btn.addEventListener('click',()=>{close(false);const input=document.querySelector('[data-sp-header] .sp-search input[type="search"]');if(input)input.focus()}));
   menu.querySelectorAll('[data-sp-mobile-mode]').forEach(btn=>btn.addEventListener('click',()=>{const next=btn.dataset.spMobileMode;menu.querySelectorAll('[data-sp-mobile-mode]').forEach(x=>x.setAttribute('aria-selected',x===btn?'true':'false'));menu.querySelectorAll('[data-sp-mobile-mode-panel]').forEach(x=>x.hidden=x.dataset.spMobileModePanel!==next)}));
   menu.querySelectorAll('[data-sp-mobile-department]').forEach(btn=>btn.addEventListener('click',()=>showMobileScreen('department-'+btn.dataset.spMobileDepartment)));
   menu.querySelectorAll('[data-sp-mobile-group]').forEach(btn=>btn.addEventListener('click',()=>showMobileScreen('group-'+btn.dataset.spMobileGroup)));
   menu.querySelectorAll('[data-sp-mobile-back]').forEach(btn=>btn.addEventListener('click',()=>showMobileScreen(btn.dataset.spMobileBack)));
   menu.querySelectorAll('[data-sp-catalog-close]').forEach(btn=>btn.addEventListener('click',()=>close(true)));
   menu.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>close(false)));
   menu.addEventListener('toggle',()=>{trigger.setAttribute('aria-expanded',menu.open?'true':'false');document.documentElement.classList.toggle('sp-catalog-open',menu.open);if(menu.open){showMode(mode);if(!desktop.matches){showMobileScreen('root');menu.querySelector('[data-sp-catalog-close]')?.focus()}}});
   menu.addEventListener('keydown',event=>{
    if(event.key==='Escape'&&menu.open){if(search&&search.value){event.preventDefault();resetSearch(true)}else{event.preventDefault();close(true)}}
    if(event.key==='Tab'&&menu.open&&!desktop.matches){const controls=[...menu.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),summary')].filter(el=>!el.closest('[hidden]'));const first=controls[0],last=controls[controls.length-1];if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus()}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus()}}
   });
   document.addEventListener('click',event=>{if(menu.open&&!menu.contains(event.target))close(false)});
   showDepartment(Math.min(department,menu.querySelectorAll('[data-sp-department]').length-1));showMode(mode);
  });
 }
 init();document.addEventListener('shopify:section:load',init);
})();

(function(){
 function init(){
  document.querySelectorAll('[data-sp-header]').forEach(function(header){
   const drawer=header.nextElementSibling?.matches('[data-sp-mobile-drawer]') ? header.nextElementSibling : document.querySelector('[data-sp-mobile-drawer]');
   const opener=header.querySelector('[data-sp-mobile-menu-open]');
   if(!drawer||!opener||opener.dataset.spMobileBound)return;
   opener.dataset.spMobileBound='true';
   const panel=drawer.querySelector('.sp-mobile-navigation__panel');
   let previousFocus=null;
   let closeTimeout;
   function focusables(){return [...panel.querySelectorAll('a[href],button:not([disabled]),summary,[tabindex]:not([tabindex="-1"])')].filter(el=>{if(!el.getClientRects().length)return false;const closed=el.closest('details:not([open])');return !closed || (el.tagName==='SUMMARY' && el.parentElement===closed)})}
   function close(){
    if(drawer.hidden)return;
    drawer.classList.remove('is-open');
    opener.setAttribute('aria-expanded','false');
    document.body.classList.remove('sp-mobile-navigation-open');
    clearTimeout(closeTimeout);
    closeTimeout=setTimeout(()=>{drawer.hidden=true;},230);
    (previousFocus||opener).focus({preventScroll:true});
   }
   function open(){
    clearTimeout(closeTimeout);
    previousFocus=document.activeElement;
    drawer.hidden=false;
    opener.setAttribute('aria-expanded','true');
    document.body.classList.add('sp-mobile-navigation-open');
    requestAnimationFrame(()=>{drawer.classList.add('is-open');panel.querySelector('[data-sp-mobile-menu-close]')?.focus({preventScroll:true})});
   }
   opener.addEventListener('click',()=>drawer.hidden?open():close());
   drawer.querySelectorAll('[data-sp-mobile-menu-close]').forEach(el=>el.addEventListener('click',close));
   drawer.addEventListener('keydown',e=>{
    if(e.key==='Escape'){e.preventDefault();close();return}
    if(e.key!=='Tab')return;
    const items=focusables();if(!items.length)return;
    const first=items[0],last=items[items.length-1];
    if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
    else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
   });
   drawer.querySelectorAll('a[href]').forEach(link=>link.addEventListener('click',()=>{drawer.classList.remove('is-open');document.body.classList.remove('sp-mobile-navigation-open');opener.setAttribute('aria-expanded','false')}));
   window.addEventListener('resize',()=>{if(window.innerWidth>749&&!drawer.hidden)close()},{passive:true});
   const badge=header.querySelector('[data-sp-mobile-cart-count]');
   if(badge && typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined' && PUB_SUB_EVENTS.cartUpdate){
    subscribe(PUB_SUB_EVENTS.cartUpdate,function(){
     fetch((window.Shopify?.routes?.root||'/')+'cart.js').then(r=>r.json()).then(cart=>{badge.textContent=cart.item_count;badge.setAttribute('aria-label',cart.item_count+' items in cart')}).catch(()=>{});
    });
   }
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();

/* Mega menu gliding pill: tracks hover/focus, leaves original navigation logic intact. */
(function(){
 function init(){
  document.querySelectorAll('[data-sp-header] [data-sp-catalog]').forEach(menu=>{
   if(menu.dataset.spGlidingPillBound==='true')return;
   menu.dataset.spGlidingPillBound='true';
   const desktop=window.matchMedia('(min-width:990px)');
   const hosts=[...menu.querySelectorAll('.sp-catalog-desktop .sp-mode-tabs, .sp-catalog-desktop [data-sp-rail-mode]')];
   if(!hosts.length)return;
   const pillByHost=new Map();
   const rows=host=>[...host.children].filter(el=>el.matches('.sp-rail-row,[data-sp-mode-tab]'));
   const selected=host=>{
    if(host.matches('.sp-mode-tabs'))return rows(host).find(el=>el.getAttribute('aria-selected')==='true');
    return rows(host).find(el=>el.classList.contains('is-active')||el.getAttribute('aria-pressed')==='true');
   };
   const place=(host,target)=>{
    const pill=pillByHost.get(host);
    if(!pill)return;
    if(!desktop.matches||!menu.open||host.hidden||!target||!target.getClientRects().length){
     pill.classList.remove('is-visible');
     return;
    }
    const container=host.getBoundingClientRect(),box=target.getBoundingClientRect();
    pill.style.setProperty('--sp-glide-x',(box.left-container.left+host.scrollLeft)+'px');
    pill.style.setProperty('--sp-glide-y',(box.top-container.top+host.scrollTop)+'px');
    pill.style.setProperty('--sp-glide-w',box.width+'px');
    pill.style.setProperty('--sp-glide-h',box.height+'px');
    pill.classList.add('is-visible');
    if(!pill.classList.contains('is-positioned')){
     requestAnimationFrame(()=>pill.classList.add('is-positioned'));
    }
   };
   const refresh=()=>{
    hosts.forEach(host=>{
     if(host.matches('[data-sp-rail-mode]')&&!host.classList.contains('is-active')) {
      pillByHost.get(host)?.classList.remove('is-visible');
      return;
     }
     const focused=host.contains(document.activeElement)?document.activeElement.closest('.sp-rail-row,[data-sp-mode-tab]'):null;
     place(host,focused&&host.contains(focused)?focused:selected(host));
    });
   };
   let queued=false;
   const schedule=()=>{
    if(queued)return;queued=true;
    requestAnimationFrame(()=>{queued=false;if(menu.isConnected)refresh()});
   };
   hosts.forEach(host=>{
    host.classList.add('sp-glide-list');
    const pill=document.createElement('span');
    pill.className='sp-glide-pill';
    pill.setAttribute('data-sp-glide-pill','');
    pill.setAttribute('aria-hidden','true');
    host.prepend(pill);
    pillByHost.set(host,pill);
    rows(host).forEach(row=>{
     row.addEventListener('pointerenter',event=>{
      if(event.pointerType==='mouse'||event.pointerType==='pen')place(host,row);
     });
     row.addEventListener('focus',()=>place(host,row));
     row.addEventListener('click',schedule);
    });
    host.addEventListener('pointerleave',schedule);
    host.addEventListener('focusout',schedule);
    host.addEventListener('scroll',schedule,{passive:true});
   });
   menu.addEventListener('toggle',schedule);
   menu.querySelectorAll('[data-sp-mode-tab],[data-sp-department]').forEach(el=>el.addEventListener('click',schedule));
   if(window.ResizeObserver){
    const ro=new ResizeObserver(schedule);
    hosts.forEach(el=>ro.observe(el));
    menu.addEventListener('toggle',()=>{if(!menu.isConnected)ro.disconnect()});
   }
   window.addEventListener('resize',schedule,{passive:true});
   desktop.addEventListener('change',schedule);
   schedule();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
 else init();
 document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spp-collection-main"] && !Shopify.designMode) return;
  try {
    
(function(){
  function storageKey(section){return 'sppAvailabilityOptOut:'+window.location.pathname+':'+section.dataset.availabilityParam}
  function setAvailabilityPreference(section,isActive){try{if(isActive)sessionStorage.removeItem(storageKey(section));else sessionStorage.setItem(storageKey(section),'1')}catch(error){}}
  function initialize(section){
    if(section.dataset.sppReady==='true')return;section.dataset.sppReady='true';
    var availabilityParam=section.dataset.availabilityParam;var availabilityValue=section.dataset.availabilityValue;
    if(section.dataset.defaultInStock==='true'&&availabilityParam&&availabilityValue&&!(window.Shopify&&window.Shopify.designMode)){
      var url=new URL(window.location.href);var optedOut=false;try{optedOut=sessionStorage.getItem(storageKey(section))==='1'}catch(error){}
      if(!url.searchParams.has(availabilityParam)&&!optedOut){url.searchParams.set(availabilityParam,availabilityValue);url.searchParams.delete('page');window.location.replace(url.toString());return}
    }
    section.addEventListener('click',function(event){
      var opener=event.target.closest('[data-sp-open-dialog]');if(opener){var dialog=document.getElementById(opener.dataset.spOpenDialog);if(dialog&&dialog.showModal)dialog.showModal();return}
      var closer=event.target.closest('[data-sp-close-dialog]');if(closer){closer.closest('dialog').close();return}
      if(event.target.closest('[data-sp-remove-availability],[data-sp-clear-all]'))setAvailabilityPreference(section,false);
    });
    section.addEventListener('change',function(event){if(event.target.matches('[data-sp-auto-submit]')){event.target.form.submit();return}if(event.target.matches('[data-sp-availability-input]'))setAvailabilityPreference(section,event.target.checked)});
    section.addEventListener('submit',function(event){var form=event.target.closest('.sp-collection-filter-form');if(!form)return;var inputs=form.querySelectorAll('[data-sp-availability-input]');if(inputs.length){var active=Array.prototype.some.call(inputs,function(input){return input.checked});setAvailabilityPreference(section,active)}});
    // Toggle accessible grid/list layout while retaining user preference in this tab.
    var viewPreference='sppCollectionView:'+window.location.pathname;
    function applyView(view){
      var isList=view==='list';
      section.classList.toggle('sp-ref-is-list',isList);
      section.querySelectorAll('[data-sp-collection-view]').forEach(function(button){
        button.setAttribute('aria-pressed',String(button.dataset.spCollectionView===view));
      });
    }
    try{applyView(sessionStorage.getItem(viewPreference)==='list'?'list':'grid')}catch(error){applyView('grid')}
    section.querySelectorAll('[data-sp-collection-view]').forEach(function(button){
      button.addEventListener('click',function(){
        var view=button.dataset.spCollectionView;
        applyView(view);
        try{sessionStorage.setItem(viewPreference,view)}catch(error){}
      });
    });
    section.querySelectorAll('.sp-collection-dialog').forEach(function(dialog){dialog.addEventListener('click',function(event){if(event.target===dialog)dialog.close()})});
    document.addEventListener('click',function(event){if(event.target.closest('.sp-collection-filter'))return;section.querySelectorAll('.sp-collection-filter[open]').forEach(function(filter){filter.removeAttribute('open')})});
    document.addEventListener('keydown',function(event){if(event.key==='Escape')section.querySelectorAll('.sp-collection-filter[open]').forEach(function(filter){filter.removeAttribute('open')})});
  }
  function start(){document.querySelectorAll('[data-sp-collection]').forEach(initialize)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();document.addEventListener('shopify:section:load',start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spp-new-arrivals"] && !Shopify.designMode) return;
  try {
    
function sppNewArrivals(){document.querySelectorAll('.spp-new').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const track=root.querySelector('.spp-new__products');root.querySelectorAll('[data-new-scroll]').forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.newScroll)*(track.clientWidth+16),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})));});}sppNewArrivals();document.addEventListener('shopify:section:load',sppNewArrivals);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spp-product-description"] && !Shopify.designMode) return;
  try {
    
(function(){
  function normalized(value){
    return value.replace(/[^a-z]/gi,'').toLowerCase();
  }
  function init(scope){
    scope.querySelectorAll('[data-sp-description]').forEach(description=>{
      if(description.dataset.bound)return;
      description.dataset.bound='1';
      const elements=[...description.children];
      let featureHeading=null;
      let featureList=null;
      let boxHeading=null;
      elements.forEach(element=>{
        const label=normalized(element.textContent);
        if(!featureHeading&&['keyfeatures','features'].includes(label)&&element.matches('h1,h2,h3,h4,h5,h6,p,strong'))featureHeading=element;
        if(!boxHeading&&['whatsinthebox','whatisinthebox'].includes(label)&&element.matches('h1,h2,h3,h4,h5,h6,p,strong'))boxHeading=element;
      });
      if(featureHeading){
        let sibling=featureHeading.nextElementSibling;
        while(sibling&&!sibling.matches('ul,ol,h1,h2,h3,h4,h5,h6'))sibling=sibling.nextElementSibling;
        if(sibling?.matches('ul,ol'))featureList=sibling;
      }
      if(boxHeading){
        const boxList=boxHeading.nextElementSibling;
        if(boxList?.matches('ul,ol'))boxList.remove();
        boxHeading.remove();
      }
      if(featureList){
        const heading=document.createElement('h3');
        heading.className='sp-pdp-feature-heading';
        heading.textContent=description.dataset.keyFeaturesLabel;
        featureHeading.replaceWith(heading);
        featureList.classList.add('sp-pdp-feature-list');
        if(featureList.children.length>=6)featureList.classList.add('has-many-features');
        [...featureList.children].forEach(item=>{
          if(description.dataset.isTv==='true'&&normalized(item.textContent).includes('tvdeliveryavailableingautengonly'))item.remove();
        });
      }
      if(description.dataset.isTv==='true'){
        [...description.querySelectorAll('p')].forEach(paragraph=>{
          if(normalized(paragraph.textContent).includes('tvdeliveryavailableingautengonly'))paragraph.remove();
        });
      }
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spp-product-main"] && !Shopify.designMode) return;
  try {
    
(function(){
 function init(){document.querySelectorAll('[data-sp-product]').forEach(root=>{
  if(root.dataset.bound)return;root.dataset.bound='1';
  const media=[...root.querySelectorAll('[data-media-id]')],thumbs=[...root.querySelectorAll('[data-sp-thumb]')],dialogThumbs=[...root.querySelectorAll('[data-sp-dialog-thumb]')],dots=[...root.querySelectorAll('[data-sp-dot]')];
  let active=Math.max(0,media.findIndex(item=>!item.hidden));
  function showMedia(index){if(!media.length)return;active=(index+media.length)%media.length;
   media.forEach((item,i)=>{item.hidden=i!==active;if(item.hidden)item.querySelectorAll('video').forEach(video=>video.pause());});
   thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===active)));
   dialogThumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===active)));
   dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===active)));
   thumbs[active]?.scrollIntoView({block:'nearest',inline:'nearest'});
   if(root.querySelector('dialog')?.open)dialogThumbs[active]?.scrollIntoView({block:'nearest',inline:'nearest'});
  }
  thumbs.forEach(thumb=>thumb.addEventListener('click',()=>showMedia(media.findIndex(item=>item.dataset.mediaId===thumb.dataset.spThumb))));
  dialogThumbs.forEach(thumb=>thumb.addEventListener('click',()=>{showMedia(media.findIndex(item=>item.dataset.mediaId===thumb.dataset.spDialogThumb));renderDialogMedia();}));
  dots.forEach(dot=>dot.addEventListener('click',()=>showMedia(Number(dot.dataset.spDot))));
  root.querySelector('[data-sp-prev]')?.addEventListener('click',()=>showMedia(active-1));root.querySelector('[data-sp-next]')?.addEventListener('click',()=>showMedia(active+1));
  let touchX;const stage=root.querySelector('.sp-pdp-stage');stage.addEventListener('touchstart',e=>{touchX=e.touches[0].clientX;},{passive:true});stage.addEventListener('touchend',e=>{const delta=touchX-e.changedTouches[0].clientX;if(Math.abs(delta)>50)showMedia(active+(delta>0?1:-1));},{passive:true});
  const dialog=root.querySelector('dialog'),dialogMedia=root.querySelector('[data-sp-dialog-media]'),viewFull=root.querySelector('[data-sp-view-full]');
  const zoomToggle=root.querySelector('[data-sp-dialog-zoom-toggle]');
  let zoomEnabled=false;
  const finePointer=!!(window.matchMedia&&window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  function hideZoomLens(){dialogMedia?.querySelector('.sp-pdp-zoom-lens')?.classList.remove('is-visible');}
  function updateZoomState(){
    if(!dialogMedia)return;
    const hasImage=!!dialogMedia.querySelector('img');
    if(zoomToggle){
      zoomToggle.hidden=!hasImage;
      zoomToggle.setAttribute('aria-pressed',String(zoomEnabled&&hasImage));
      zoomToggle.setAttribute('aria-label',zoomEnabled?'Disable image magnifier':'Enable image magnifier');
    }
    dialogMedia.classList.toggle('is-zoom-enabled',zoomEnabled&&hasImage);
    hideZoomLens();
  }
  function magnifyAt(clientX,clientY){
    if(!zoomEnabled||!dialogMedia)return;
    const img=dialogMedia.querySelector('img'),lens=dialogMedia.querySelector('.sp-pdp-zoom-lens');
    if(!img||!lens||!img.naturalWidth||!img.naturalHeight){hideZoomLens();return;}
    const r=img.getBoundingClientRect(),container=dialogMedia.getBoundingClientRect();
    if(!r.width||!r.height)return;
    const fit=Math.min(r.width/img.naturalWidth,r.height/img.naturalHeight);
    const width=img.naturalWidth*fit,height=img.naturalHeight*fit;
    const left=r.left+(r.width-width)/2,top=r.top+(r.height-height)/2;
    if(clientX<left||clientX>left+width||clientY<top||clientY>top+height){hideZoomLens();return;}
    const factor=2.35,lensSize=lens.getBoundingClientRect().width||188;
    const photo=img.currentSrc||img.src;
    if(lens.dataset.zoomSource!==photo){
      lens.style.backgroundImage='url("'+photo.replace(/"/g,'%22')+'")';
      lens.dataset.zoomSource=photo;
    }
    lens.style.backgroundSize=(width*factor)+'px '+(height*factor)+'px';
    lens.style.backgroundPosition=(lensSize/2-(clientX-left)*factor)+'px '+(lensSize/2-(clientY-top)*factor)+'px';
    lens.style.left=(clientX-container.left)+'px';
    lens.style.top=(clientY-container.top)+'px';
    lens.classList.add('is-visible');
  }
  zoomToggle?.addEventListener('click',()=>{
    zoomEnabled=!zoomEnabled;
    updateZoomState();
    if(zoomEnabled){
      const img=dialogMedia.querySelector('img');
      if(img){
        const showCentre=()=>{const r=img.getBoundingClientRect();magnifyAt(r.left+r.width/2,r.top+r.height/2);};
        if(img.complete)showCentre();else img.addEventListener('load',showCentre,{once:true});
      }
    }
  });
  dialogMedia?.addEventListener('pointermove',e=>magnifyAt(e.clientX,e.clientY));
  dialogMedia?.addEventListener('pointerleave',hideZoomLens);
  dialogMedia?.addEventListener('pointerdown',e=>{
    if(e.pointerType==='touch'&&zoomEnabled){e.preventDefault();magnifyAt(e.clientX,e.clientY);}
  });

  function renderDialogMedia(){
    if(!dialogMedia||!media[active])return;
    dialogMedia.replaceChildren();
    const source=media[active],image=source.querySelector('img');
    if(image){
      const full=image.cloneNode(true);
      full.loading='eager';full.decoding='async';full.draggable=false;full.alt=image.alt;
      const highRes=source.querySelector('[data-sp-dialog-full-src]')?.dataset.spDialogFullSrc;
      if(highRes){full.removeAttribute('srcset');full.removeAttribute('sizes');full.src=highRes;}
      dialogMedia.appendChild(full);
      const lens=document.createElement('div');lens.className='sp-pdp-zoom-lens';
      lens.setAttribute('aria-hidden','true');dialogMedia.appendChild(lens);
    }else{
      const playable=source.querySelector('video,iframe,model-viewer');
      if(playable)dialogMedia.appendChild(playable.cloneNode(true));
    }
    updateZoomState();
  }
  function openDialog(){zoomEnabled=finePointer;renderDialogMedia();if(!dialog.open)dialog.showModal();document.documentElement.classList.add('sp-pdp-dialog-open');}
  viewFull?.addEventListener('click',openDialog);root.querySelectorAll('[data-sp-zoom]').forEach(button=>button.addEventListener('click',openDialog));
  root.querySelector('[data-sp-close]')?.addEventListener('click',()=>dialog.close());
  root.querySelector('[data-sp-dialog-prev]')?.addEventListener('click',()=>{showMedia(active-1);renderDialogMedia();});
  root.querySelector('[data-sp-dialog-next]')?.addEventListener('click',()=>{showMedia(active+1);renderDialogMedia();});
  dialog?.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
  dialog?.addEventListener('close',()=>{zoomEnabled=false;hideZoomLens();document.documentElement.classList.remove('sp-pdp-dialog-open');});
  dialog?.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'){e.preventDefault();showMedia(active-1);renderDialogMedia();}if(e.key==='ArrowRight'){e.preventDefault();showMedia(active+1);renderDialogMedia();}});
  const variants=JSON.parse(root.querySelector('[data-sp-variants]').textContent),rules=JSON.parse(root.querySelector('[data-sp-variant-rules]').textContent),strings=JSON.parse(root.querySelector('[data-sp-strings]').textContent);
  const form=root.querySelector('form'),input=form.querySelector('[name="id"]'),qty=form.querySelector('[name="quantity"]'),add=form.querySelector('.spap-btn-cart'),buy=form.querySelector('.spap-btn-buynow');
  function money(cents){if(root.dataset.currency==='ZAR')return 'R '+new Intl.NumberFormat('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}).format(cents/100);return new Intl.NumberFormat('en-ZA',{style:'currency',currency:root.dataset.currency||'ZAR'}).format(cents/100);}
  function savedMoney(cents){if(root.dataset.currency==='ZAR')return 'R'+new Intl.NumberFormat('en-US',{minimumFractionDigits:0,maximumFractionDigits:2}).format(cents/100);return new Intl.NumberFormat('en-ZA',{style:'currency',currency:root.dataset.currency||'ZAR',minimumFractionDigits:0,maximumFractionDigits:2}).format(cents/100);}
  function update(){const selected=[...root.querySelectorAll('[data-sp-option]:checked')].sort((a,b)=>Number(a.dataset.spOption)-Number(b.dataset.spOption)).map(option=>option.value);const variant=selected.length?variants.find(item=>item.options.every((option,i)=>option===selected[i])):variants.find(item=>String(item.id)===input.value);
   input.value=variant?variant.id:'';input.disabled=!variant;const available=!!variant?.available;add.disabled=!available;buy.disabled=!available;buy.hidden=!available;add.parentElement.dataset.sppUnavailable=String(!available);
   const pickupHeading=root.querySelector('[data-sp-pickup-heading]');if(pickupHeading)pickupHeading.textContent=available?'Store Pickup Available':'Ask About Store Pickup';const addLabel=add.querySelector('[data-sp-add-label]'),addIcon=add.querySelector('[data-sp-add-icon]');if(addLabel)addLabel.textContent=available?strings.add:variant?strings.sold:strings.unavailable;if(addIcon)addIcon.hidden=!available;buy.textContent=available?strings.buy:variant?strings.sold:strings.unavailable;
   root.querySelector('[data-sp-price]').textContent=variant?money(variant.price):'—';const sale=!!variant&&variant.compare_at_price>variant.price;const compare=root.querySelector('[data-sp-compare]'),discount=root.querySelector('[data-sp-discount]');compare.hidden=!sale;discount.hidden=!sale;if(sale){compare.textContent=money(variant.compare_at_price);discount.textContent='SAVE '+Math.floor((variant.compare_at_price-variant.price)*100/variant.compare_at_price)+'%';}
   const galleryDiscount=root.querySelector('[data-sp-gallery-discount]');if(galleryDiscount){galleryDiscount.hidden=!sale;if(sale)galleryDiscount.textContent='-'+Math.floor((variant.compare_at_price-variant.price)*100/variant.compare_at_price)+'% OFF';}const dialogDiscount=root.querySelector('[data-sp-dialog-discount]');if(dialogDiscount){dialogDiscount.hidden=!sale;if(sale)dialogDiscount.textContent=strings.save+' '+savedMoney(variant.compare_at_price-variant.price);}
   root.querySelectorAll('[data-sp-option]').forEach(option=>{const chosen=[...selected];chosen[Number(option.dataset.spOption)-1]=option.value;const candidate=variants.find(item=>item.options.every((value,i)=>value===chosen[i]));option.setAttribute('aria-disabled',String(!candidate?.available));option.nextElementSibling?.classList.toggle('is-unavailable',!candidate?.available);});
   if(variant){const rule=rules.find(item=>item.id===variant.id);if(rule){qty.min=rule.min;qty.step=rule.step;if(rule.max!==null)qty.max=rule.max;else qty.removeAttribute('max');if(Number(qty.value)<rule.min)qty.value=rule.min;}
    if(variant.featured_media){const index=media.findIndex(item=>Number(item.dataset.mediaId)===variant.featured_media.id);if(index>=0)showMedia(index);}
    const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
    const purchaseNode=root.querySelector('.sp-pdp-purchase'),helpLink=root.querySelector('[data-sp-whatsapp-help]'),pickupLink=root.querySelector('.sp-pdp-store-pickup__link');if(purchaseNode&&(helpLink||pickupLink)){let message=(purchaseNode.dataset.spWhatsappPrefix||'Hi Smart Pick & Pay, I need help with this product:')+' '+purchaseNode.dataset.spShareTitle;if(purchaseNode.dataset.spDefaultVariant==='false')message+=' — '+variant.title;message+=': '+purchaseNode.dataset.spShareUrl;const contact=(purchaseNode.dataset.spWhatsappBase||'https://wa.me/27632422467')+'?text='+encodeURIComponent(message);if(helpLink)helpLink.href=contact;if(pickupLink)pickupLink.href=contact;}
   }
  }
  root.querySelectorAll('[data-sp-option]').forEach(option=>option.addEventListener('change',update));
  function quantity(delta){const min=Number(qty.min)||1,step=Number(qty.step)||1,max=qty.max?Number(qty.max):Infinity;qty.value=Math.max(min,Math.min(max,(Number(qty.value)||min)+delta*step));qty.dispatchEvent(new Event('change',{bubbles:true}));}
  root.querySelector('[data-sp-minus]').addEventListener('click',()=>quantity(-1));root.querySelector('[data-sp-plus]').addEventListener('click',()=>quantity(1));
  const purchase=root.querySelector('.sp-pdp-purchase'),shareStatus=root.querySelector('[data-sp-share-status]'),shareData={title:purchase?.dataset.spShareTitle||document.title,url:purchase?.dataset.spShareUrl||location.href};
  let shareStatusTimer;
  async function copyShareUrl(){let copied=false;try{if(navigator.clipboard&&window.isSecureContext){await navigator.clipboard.writeText(shareData.url);copied=true;}}catch(error){copied=false;}if(!copied){const field=document.createElement('textarea');field.value=shareData.url;field.setAttribute('readonly','');field.style.position='fixed';field.style.opacity='0';document.body.appendChild(field);field.select();try{copied=document.execCommand('copy');}catch(error){copied=false;}field.remove();}if(shareStatus){window.clearTimeout(shareStatusTimer);shareStatus.querySelector('[data-sp-share-status-text]').textContent=copied?'Product link copied':(strings.copyError||'Could not copy link');shareStatus.classList.toggle('is-error',!copied);shareStatus.hidden=false;shareStatusTimer=window.setTimeout(()=>{shareStatus.hidden=true;},3500);}return copied;}
  root.querySelector('[data-sp-copy-link]')?.addEventListener('click',copyShareUrl);
  root.querySelectorAll('[data-sp-share-fallback]').forEach(button=>button.addEventListener('click',async()=>{if(navigator.share){try{await navigator.share(shareData);return;}catch(error){if(error?.name==='AbortError')return;}}await copyShareUrl();}));
 });}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spp-product-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
 function init(){const widget=document.getElementById('judgeme_product_reviews');if(!widget||widget.dataset.spBound)return;widget.dataset.spBound='1';
  const empty=widget.parentElement.querySelector('[data-sp-review-empty]');
  const update=()=>{const inner=widget.querySelector('[data-number-of-reviews]');if(!inner)return;const value=inner.getAttribute('data-number-of-reviews');if(value===null||value==='')return;empty.hidden=Number(value)!==0;widget.closest('.sp-pdp-reviews').classList.toggle('sp-pdp-no-reviews',Number(value)===0);};
  new MutationObserver(update).observe(widget,{childList:true,subtree:true,attributes:true,attributeFilter:['data-number-of-reviews']});update();
 }
 init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spp-weekend-deal"] && !Shopify.designMode) return;
  try {
    
function sppWeekendInit(root){
 root.querySelectorAll('.spp-weekend').forEach(section=>{
  if(section.dataset.weekendReady)return;
  section.dataset.weekendReady='true';
  const track=section.querySelector('.spp-weekend__products');
  const hasProducts=Boolean(track && track.querySelector('.ab-product'));
  const arrows=section.querySelectorAll('[data-weekend-scroll]');
  const pager=section.querySelector('[data-weekend-pager]');
  const range=pager.querySelector('input');
  const dots=pager.querySelector('.spp-weekend__dots');
  let positions=[];
  const refresh=()=>{
   const maximum=Math.max(0,track.scrollWidth-track.clientWidth);
   const overflow=maximum>2;
   pager.hidden=!overflow;
   arrows.forEach(button=>{button.hidden=!overflow;button.disabled=button.dataset.weekendScroll==='-1'?track.scrollLeft<=2:track.scrollLeft>=maximum-2;});
   range.value=maximum?Math.min(100,Math.max(0,track.scrollLeft/maximum*100)):0;
   let nearest=0;
   positions.forEach((position,index)=>{if(Math.abs(position-track.scrollLeft)<Math.abs(positions[nearest]-track.scrollLeft))nearest=index;});
   [...dots.children].forEach((button,index)=>button.setAttribute('aria-current',String(index===nearest)));
  };
  const rebuild=()=>{
   const maximum=Math.max(0,track.scrollWidth-track.clientWidth);
   positions=[0];
   const steps=Math.min(4,Math.max(1,Math.ceil(maximum/Math.max(1,track.firstElementChild?.getBoundingClientRect().width||track.clientWidth))));
   for(let i=1;i<=steps;i++)positions.push(maximum*i/steps);
   dots.replaceChildren();
   positions.forEach((position,index)=>{
    const button=document.createElement('button');
    button.type='button';button.className='spp-weekend__dot';
    button.setAttribute('aria-label',pager.dataset.dotLabel.replace('[number]',String(index+1)));
    button.setAttribute('aria-controls',track.id);
    button.addEventListener('click',()=>track.scrollTo({left:position,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'}));
    dots.append(button);
   });
   refresh();
  };
  range.addEventListener('input',()=>track.scrollTo({left:(track.scrollWidth-track.clientWidth)*Number(range.value)/100,behavior:'instant'}));
  arrows.forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.weekendScroll)*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})));
  track.addEventListener('scroll',refresh,{passive:true});
  const observer=new ResizeObserver(rebuild);observer.observe(track);rebuild();
  const raw=section.dataset.weekendEnd.trim();
  const end=/(Z|[+-]\d{2}:\d{2})$/i.test(raw)?Date.parse(raw):NaN;
  const weekly=section.dataset.weekendWeekly==='true';
  if(!weekly&&!Number.isFinite(end))return;
  const timer=section.querySelector('[data-weekend-timer]');
  let interval;
  // Roll only when a genuine clock digit changes. The existing Johannesburg-time
  // deadline calculation remains the single source of truth.
  const paintRollingUnit=(unit,value)=>{
   const host=section.querySelector('[data-weekend-unit="'+unit+'"]');
   if(!host)return;
   const next=String(value).padStart(2,'0');
   const previous=host.dataset.weekendShown;
   if(previous===next)return;
   const old=(previous||next).padStart(Math.max(next.length,(previous||'').length),'0');
   const updated=next.padStart(old.length,'0');
   const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
   const digits=[];
   const changes=[];
   for(let i=0;i<updated.length;i++){
    const windowEl=document.createElement('span');
    windowEl.className='spp-weekend__roll-window';
    windowEl.setAttribute('aria-hidden','true');
    const stack=document.createElement('span');
    stack.className='spp-weekend__roll-stack';
    const nextDigit=document.createElement('span');
    nextDigit.textContent=updated[i];
    if(previous && !reduced && old[i]!==updated[i] && typeof stack.animate==='function'){
     const oldDigit=document.createElement('span');
     oldDigit.textContent=old[i];
     stack.append(oldDigit,nextDigit);
     changes.push({stack,nextDigit});
    }else{
     stack.append(nextDigit);
    }
    windowEl.append(stack);
    digits.push(windowEl);
   }
   const sr=document.createElement('span');
   sr.className='spp-weekend__roll-sr';
   sr.textContent=next;
   host.replaceChildren(sr,...digits);
   host.dataset.weekendShown=next;
   changes.forEach(({stack,nextDigit})=>{
    const animation=stack.animate(
     [{transform:'translateY(0)'},{transform:'translateY(-1.05em)'}],
     {duration:350,easing:'cubic-bezier(.22,.72,.32,1)',fill:'forwards'}
    );
    animation.onfinish=()=>{
     animation.cancel();
     stack.replaceChildren(nextDigit);
    };
   });
  };
  const update=()=>{
   const now=Date.now();
   const local=new Date(now+7200000);
   const day=local.getUTCDay();
   const midnight=Date.UTC(local.getUTCFullYear(),local.getUTCMonth(),local.getUTCDate())-7200000;
   const active=!weekly||day===5||day===6||day===0;
   const finish=weekly?midnight+(day===5?3:day===6?2:day===0?1:0)*86400000:end;
   const nextFriday=midnight+((5-day+7)%7)*86400000;
   const remaining=Math.max(0,(active?finish:nextFriday)-now);
   section.querySelector('[data-weekend-caption]').textContent=active?timer.getAttribute('aria-label'):'Next deal starts in';
   if(!remaining){timer.hidden=true;section.querySelector('[data-weekend-products]').hidden=true;section.querySelector('[data-weekend-upcoming]').hidden=false;if(interval&&!weekly)clearInterval(interval);return;}
   const showDeals=active&&hasProducts;
   timer.hidden=active&&!hasProducts;
   section.querySelector('[data-weekend-products]').hidden=!showDeals;
   section.querySelector('[data-weekend-upcoming]').hidden=showDeals;
   const values={hours:Math.floor(remaining/3600000),minutes:Math.floor(remaining%3600000/60000),seconds:Math.floor(remaining%60000/1000)};
   Object.entries(values).forEach(([unit,value])=>paintRollingUnit(unit,value));
   const millisecondsHost=section.querySelector('[data-weekend-unit="milliseconds"]');
   if(millisecondsHost)millisecondsHost.textContent=String(Math.floor((remaining%1000)/10)).padStart(2,'0');
  };
  update();if(weekly||end>Date.now())interval=setInterval(()=>{if(!section.isConnected){clearInterval(interval);observer.disconnect();return;}update();},50);
 });
}
sppWeekendInit(document);document.addEventListener('shopify:section:load',()=>sppWeekendInit(document));

  } catch(e) { console.error(e); }
})();
})();
